<div class="header">
  <header role="banner" id="headCVS" class="head-wrap" >
    <a class="cvs-mdp-skip" appCvsSetFocus targetElement="headCVS-EndNav" tabindex="0">Skip to main content</a>

    <div #mobileHeader class="mobile-header">

      <div class="mobile-nav-bar">
        <button class="mob-menu-icon toggle-nav" aria-label="Click to show-hide mobile menu"></button>
        <p>SimpleDose&trade;</p>
      </div>

      <div class="mob-menu" id="mobmenu" #mobmenu>
        <div class="mob-head">
          <a class="my-cvs icn-chevron-white-left" [href]="url">CVS Pharmacy</a>
          <ul>
            <li *ngIf="!user">
              <a title="signin" href="/pharmacy/mdp-dashboard"
                 class="mob-signin head-mob-sprite"><span class="mob-signin-icon"></span>Sign In</a>
            </li>
            <li class="mob-user-block" *ngIf="user">
                <!--user userName-->
              <span class="mob-signin head-mob-sprite"><span class="mob-signin-icon"></span>Hi, {{userName | titlecase}}</span>
              <span class="user-seperator"> | </span>
              <button title="sign out" routerLink="/logout" class=" mob-signout" (click)="signOut()">Sign Out</button>
            </li>
          </ul>
        </div>
        <div class="mob-nav-outer" *ngIf="user && orders.allOrders.length > 0 && !orders.syncPlanOrder && viewConfig.heading">
          <ul class="mob-nav">
            <li *ngFor="let item of nav" id="{{item.name}}">
              <a routerLinkActive="active" [routerLink]="item.name" href="" [title]="item.name" target="_self"
                 (click)="tabNav(item.name, $event);">{{item.name | titlecase}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="desktop-header head-c1">

      <div class="head-c1-desktop-wrapper">

        <div class="head-c1-left">
          <a class="my-cvs icn-chevron-left" [href]="url"
             (click)="applyPharmacyTag($event);">CVS Pharmacy</a>
        </div>
        <div class="head-c1-right" *ngIf="user">
            <span>Hi, {{userName | titlecase}}!</span>
            <button title="sign out" routerLink="/logout" (click)="signOut()">Sign Out</button>
        </div>
      </div>
    </div>
    <div class="desktop-header head-c2">
      <div class="head-c2-desktop-wrapper">
        <p id="headCVS-EndNav" tabindex="-1" class="p-brand">SimpleDose&trade;</p>
      </div>
    </div>

  </header>
  <div [class.overlay]="isMenuActive"
       [class.overlay-end]="!isMenuActive"
       #overlay class="toggle-nav"></div>
</div>
<div class="header__spacer"></div>
